import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import {ActionsBase, DispatchAll, IncludeResultCallbacks} from '@store/@types/alt';
import {
  AdminUserSource,
  FetchUserTableParams,
  UpdateUserActiveParams,
  UpdateUserTeamParams,
} from '@store/admin/AdminUserSource';
import {FetchUserTableResponse} from '@store/@types/UserAdmin';

interface AsyncActions {
  fetchUserTable(params: FetchUserTableParams): Promise<FetchUserTableResponse>;
  setUserTeam(params: UpdateUserTeamParams): Promise<void>;
  setUserActive(params: UpdateUserActiveParams): Promise<void>;
}

interface SyncActions {
  setLoading(): void;
}

export interface AdminUserActionsInterface
  extends IncludeResultCallbacks<AsyncActions>,
    SyncActions {}

class AdminUserActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(
      'setLoading',
      ...generateAsyncActions<AsyncActions>('fetchUserTable', 'setUserTeam', 'setUserActive')
    );
  }

  fetchUserTable(params: FetchUserTableParams) {
    return dispatch => {
      dispatch(params);
      return AdminUserSource.fetchUserTable(params).then(
        this.fetchUserTableSuccess,
        this.fetchUserTableError
      );
    };
  }

  setUserTeam(params: UpdateUserTeamParams) {
    return dispatch => {
      dispatch(params);
      return AdminUserSource.setUserTeam(params).then(
        this.setUserTeamSuccess,
        this.setUserTeamError
      );
    };
  }

  setUserActive(params: UpdateUserActiveParams) {
    return dispatch => {
      dispatch(params);
      return AdminUserSource.setUserActive(params).then(
        this.setUserActiveSuccess,
        this.setUserActiveError
      );
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(AdminUserActions);
